import highlightTermsInHtmlElement from './utils/highlightTermsInHtmlElement';

export { highlightTermsInHtmlElement };
